import { useHotkey } from '@tanstack/react-hotkeys'
import React, { useCallback, useEffect } from 'react'

import {
  setEditingFeed,
  useEditingMixFeed,
  useEditingMixState,
} from '../../../firebase/hooks/useMixes'

import { MixSlotAssignMenu } from './MixSlotAssignMenu'
import { MixSlotPositionMenu } from './MixSlotPositionMenu'

import './MixSlotMenu.scss'

const MixSlotMenu = () => {
  const mix = useEditingMixState()
  const { idx: feedIdx, mode } = useEditingMixFeed()
  const feed = feedIdx !== null ? mix?.feeds[feedIdx] : undefined

  const exitEdit = useCallback(() => setEditingFeed(null), [])
  useHotkey('Escape', exitEdit)

  useEffect(() => {
    const exitEditOnOutsideClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (target && !target.closest?.('.floor') && target.closest?.('html'))
        exitEdit()
    }
    window.addEventListener('click', exitEditOnOutsideClick)
    return () => window.removeEventListener('click', exitEditOnOutsideClick)
  }, [exitEdit, feed, mode])

  if (!feed) return null

  if (feed.media && mode !== 'swap') return <MixSlotPositionMenu />

  return <MixSlotAssignMenu />
}

export { MixSlotMenu }
